// Words a creature nickname may not contain (shared/nametags.ts). Kept small on
// purpose: the common slurs and the crudest profanity, nothing clever. Names are
// checked after lower-casing, dropping accents and undoing common number swaps
// (0 -> o, 1 -> i, 3 -> e, 4 -> a, 5 -> s, 7 -> t, @ -> a, $ -> s).
//
// ANYWHERE: blocked wherever the letters appear, even run together or split by
// spaces and punctuation ("f u c k"). Only words that are not part of ordinary
// English words go here.
export const BLOCK_ANYWHERE: readonly string[] = [
  'fuck', 'shit', 'cunt', 'bitch', 'whore', 'slut', 'bastard', 'asshole', 'dildo', 'jizz', 'wank', 'twat', 'bollock',
  'nigger', 'nigga', 'faggot', 'retard', 'tranny', 'kike', 'wetback', 'beaner', 'chingchong', 'raghead', 'towelhead',
  'hitler', 'nazi', 'kkk', 'porn', 'penis', 'vagina', 'pedo', 'molest',
];

// WHOLE WORD: blocked only as a whole word, because the letters also sit inside
// ordinary words (cock in cockatrice, coon in raccoon, rape in grape).
export const BLOCK_WORDS: readonly string[] = [
  'ass', 'arse', 'cock', 'dick', 'pussy', 'tits', 'tit', 'cum', 'fag', 'fags', 'dyke', 'spic', 'chink', 'gook', 'coon',
  'paki', 'negro', 'rape', 'rapist', 'heil', 'hoe', 'hoes', 'skank', 'damn', 'piss', 'prick', 'boob', 'boobs', 'sex',
];
